import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CHECKOUT_URL, offerChecklist } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
export function Offer() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ink-850" data-id="element-133" data-mp="307j2a0m3mzx0">
      <div className="mx-auto max-w-2xl px-5 py-16 md:py-20" data-id="element-134" data-mp="356cbhgucs4rd">
        <div className="rounded-3xl border-[3px] border-brand-green bg-ink-card p-7 shadow-panel md:p-10" data-id="element-135" data-mp="357nh7m7czml4">
          <h2 id="oferta-title" className="text-center font-display text-2xl font-black leading-tight text-white md:text-3xl" data-id="element-136" data-mp="3a3clg2ubprnr">
            MÉTODO PARA PADRES DE FUTBOLISTAS
          </h2>
          <p className="mt-3 text-center text-sm font-bold tracking-widest text-brand-gold uppercase" data-id="element-137" data-mp="3nwu2ngzjesam">
            100% DIGITAL · 5 MÓDULOS + 2 BONOS
          </p>
          <ul className="mt-8 space-y-3" data-id="element-138" data-mp="3sxrl7uoglocn">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-3" data-id="element-139" data-mp="1q5axj78inmt">
                <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-green text-black" data-id="element-140" data-mp="1klzunc6htsma">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} data-id="element-141" data-mp="1bk0bad80acg6" />
                </span>
                <span className="text-[15px] text-body" data-id="element-142" data-mp="16m8izi3g8obg">{item}</span>
              </li>)}
          </ul>
          <div className="mt-8 rounded-2xl bg-ink-950 px-6 py-8 text-center" data-id="element-143" data-mp="23c7u9kazi0xq">
            <p className="text-lg font-semibold text-subtle line-through" data-id="element-144" data-mp="1zamftuisxelf">US$ 87</p>
            <p className="mt-1 font-display text-5xl font-black text-white md:text-6xl" data-id="element-145" data-mp="1ujo12zdgooka">US$ 15</p>
            <span className="mt-4 inline-block rounded-full bg-brand-gold px-4 py-1.5 text-xs font-black uppercase tracking-[0.12em] text-black" data-id="element-146" data-mp="1pkkuvblqwcaq">
              Precio especial de lanzamiento
            </span>
            <p className="mt-4 text-xs leading-relaxed text-subtle" data-id="element-147" data-mp="2i9icrdm1o72y">
              Precio en dólares estadounidenses. Al finalizar tu compra, siempre pagarás en tu moneda
              local.
            </p>
          </div>
          <div className="mt-7" data-id="element-148" data-mp="364tsits1ouy7">
            <CtaButton size="xl" fullWidth href={CHECKOUT_URL} data-id="element-149" data-mp="363seqhjn9ucs">
              Obtener el método ahora
            </CtaButton>
          </div>
          <p className="mt-5 text-center text-sm text-subtle" data-id="element-150" data-mp="2weioz8c9wnru">
            🔒 Pago seguro · ⚡ Acceso inmediato · 💳 Pago único · ✅ Garantía 7 días
          </p>
          <p className="mt-2 text-center text-xs text-subtle" data-id="element-151" data-mp="2idod2fq0o4of">
            Material 100% digital en PDF: no hay envíos ni mensualidades.
          </p>
          <p className="mt-2 text-center text-xs leading-relaxed text-subtle" data-id="element-152" data-mp="29et97aag36oa">
            Este material es educativo y no reemplaza la asesoría de un abogado especializado en
            derecho deportivo.
          </p>
        </div>
      </div>
    </section>;
}